import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import {
  LineChartPro,
  CurveType,
  ChartsGrid,
  LinePlot,
  MarkPlot,
  lineElementClasses,
  markElementClasses,
} from "@mui/x-charts-pro";
import { CustomItemTooltip } from '../../../../../../../ResuableChartTooltip/CustomItemTooltip';

interface MetricMonthsGraphProps {
  data: { y1: number; y2: number }[];
  months: string[];
}

const MetricMonthsGraph: React.FC<MetricMonthsGraphProps> = ({ data = [], months = [] }) => {
  // Reverse the months and data to show May 2024 first (older dates first)
  const reversedMonths = [...months].reverse();
  const reversedData = [...data].reverse();
  
  const chartProps = {
    height: 400,
    series: [
      {
        label: "Forecast",
        data: reversedData.length ? reversedData.map((v) => v.y1) : [0], // Provide default data if empty
        color: "#6200EE",
        curve: "linear" as CurveType,
        disableLine: true,
      },
      {
        label: "Actual",
        data: reversedData.length ? reversedData.map((v) => v.y2) : [0], // Provide default data if empty
        color: "#3CC3DF",
        curve: "linear" as CurveType,
        disableLine: true,
      },
    ],
  };

  return (
    <Stack sx={{ width: "100%" }}>
      <Box sx={{ width: "100%" }}>
        <LineChartPro
          {...chartProps}          xAxis={[
            {
              scaleType: "point",
              id: "my-x-axis",
              data: reversedMonths.length ? reversedMonths : ["No Data"], // Reversed months for X-axis
            },
          ]}
          sx={{
            [`& .MuiChartsAxis-tickLabel`]: {
              fill: "grey !important", // Label color for X and Y axes
            },
            [`& .MuiChartsAxis-tick`]: {
              stroke: "grey !important", // Tick color for X and Y axes
            },
            [`& .${lineElementClasses.root}`]: {
              strokeWidth: 2,
            },
            [`& .${markElementClasses.root}`]: {
              scale: "0.6",
              strokeWidth: 2,
              "&:hover": {
                scale: "1.2",
                strokeWidth: 5,
                opacity: "0.6",
              },
            },
          }}
          slotProps={{
            legend: {
              direction: "row",
              position: {
                vertical: "bottom",
                horizontal: "left",
              },
              labelStyle: {
                fontSize: 12,
              },
              itemMarkWidth: 12,
              itemMarkHeight: 2,
              markGap: 8,
              itemGap: 10,
              padding: 28,
            },
          }}
          margin={{ left: 60, right: 60, top: 25, bottom: 84 }}
          leftAxis={{}}
          rightAxis={null}
        >
          <ChartsGrid horizontal />
          <CustomItemTooltip />
          <LinePlot />
          <MarkPlot />
        </LineChartPro>
      </Box>
    </Stack>
  );
};

export default MetricMonthsGraph;
